module.exports = __webpack_public_path__ + "static/media/geel.d24820ae.jpg";